import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { WhitelabelService } from '../../domain/whitelabel.service';
import { EditSelectionService } from '../edit-selection.service';
import { ElementType, IQuestionConfig, QuestionState } from '../models';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { TextToSpeechService } from '../text-to-speech.service';
import { IContentElementText, IContentElementTextParagraph, TextParagraphStyle } from './model';
@Component({
  selector: 'element-render-text',
  templateUrl: './element-render-text.component.html',
  styleUrls: ['./element-render-text.component.scss']
})
export class ElementRenderTextComponent implements OnInit {

  @Input() element:IContentElementText;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() questionPubSub?: QuestionPubSub;
  @Input() currentQuestion: IQuestionConfig;

  constructor(
    private whitelabel: WhitelabelService,
    private text2Speech: TextToSpeechService,
    public editSelection: EditSelectionService
  ) { }

  dynamicText='';
  entryIdList=new Map();

  ngOnInit() {
    this.isInitDynamicText();
  }

  initElementSubState_NumberInputAndMCQ(){
    this.questionPubSub.allSub().subscribe(payload => {
      if (!this.entryIdList.has(payload.entryId) || !this.element.isShowNumberInputOrMCQResponse) return;
      const state = this.questionState[payload.entryId]
      switch (state.type) {
        case ElementType.MCQ:
          if (!state.selections.length) return ;
          const selection = state.selections[0]
          let selectionStr = selection.content
          if (selection.paragraphStyle == TextParagraphStyle.ADVANCED_INLINE && selection.advancedList) {
            selectionStr = ''
            selection.advancedList.forEach((el)=>{
              if (el.elementType==ElementType.TEXT) {
                selectionStr += el.caption
              }
            })
          }
          this.updateNumberInputOrMQCResponseString(payload, selectionStr)
          return;
        case ElementType.INPUT_NUMBER:
          this.updateNumberInputOrMQCResponseString(payload, state.value)
          return
        default:
          return;
      }
    });
  }
  
  ngOnChange(){
    this.isInitDynamicText()
  }

  initElementSub(){
    this.questionPubSub.allSub().subscribe(payload => {
      if (payload.entryId !== this.element.fromEntryId || !this.element.isShowDynamicText) return;
      const state = this.questionState[payload.entryId]
      switch (state.type) {
        case ElementType.MCQ:
          if (!state.selections.length) return ;
          const selection = state.selections[0].content
          this.dynamicText = selection.toString();
          return;
        default:
          return;
      }
    });
  }

  isInitDynamicText(){
    if(this.element.isShowDynamicText){
      this.dynamicText = ''
      this.initElementSub()
    }
    if(this.element.isShowNumberInputOrMCQResponse){
      this.getEntryIdPramsFromFormat()
      this.initElementSubState_NumberInputAndMCQ();
    }
  }

  getEntryIdPramsFromFormat(){
    const regex = /{{\d+}}/g;
    const entryIdStrings = this.element.showhowNumberInputOrMCQResponseFormat.match(regex)
    entryIdStrings?.forEach(entryIdString => {
      this.entryIdList.set(Number(entryIdString.replace('{{', '').replace('}}', '')), '')
    })
    if(this.element.isDynamicTextEval){
      this.updateNumberInputOrMQCResponseString(null, null)
    }
  }

  updateNumberInputOrMQCResponseString(payload, value){
    const isSum = this.element.isDynamicTextEval;
    if((!value || !payload.entryId) && !isSum){
      this.dynamicText = ''
      return;
    } else if(payload?.entryId && value){
      this.entryIdList.set(payload.entryId, value)
    }
    if(!Array.from(this.entryIdList.values()).includes('') || isSum){
      let resultStr = this.element.showhowNumberInputOrMCQResponseFormat
      this.entryIdList.forEach((value, key)=>{
        let idString = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g');
        resultStr = resultStr.replace(idString, value);
      })
      if(isSum){
        let sum = 0
        const inputArr = resultStr.split(',')
        inputArr.forEach(val=>{
          if(!isNaN(+val)){
            sum += +val;
          }
        })
        resultStr = sum.toString();
      }
      this.dynamicText = resultStr;
    }
  }

  get parseSimpleText(){
    if(this.element.isShowNumberInputOrMCQResponse || this.element.isShowDynamicText){
      return this.parseTextFormat(this.dynamicText);
    } else {
      return this.parseTextFormat(this.element.caption);
    }
  }


  isParagraphs(){
    return this.element.paragraphStyle === TextParagraphStyle.PARAGRAPHS;
  }
  isHeading(){
    return this.element.paragraphStyle === TextParagraphStyle.HEADLINE;
  }
  isHeadingSmall(){
    return this.element.paragraphStyle === TextParagraphStyle.HEADLINE_SMALL;
  }
  isBody(){
    return this.element.paragraphStyle === TextParagraphStyle.REGULAR;
  }
  isSmall(){
    return this.element.paragraphStyle === TextParagraphStyle.SMALL;
  }
  isBulletList(){
    return this.element.paragraphStyle === TextParagraphStyle.BULLET;
  }
  isNumberedList(){
    return this.element.paragraphStyle === TextParagraphStyle.NUMBERED;
  }

  isSimpleText(){
    if (this.element.paragraphStyle === TextParagraphStyle.HEADLINE){ return true }
    if (this.element.paragraphStyle === TextParagraphStyle.HEADLINE_SMALL){ return true }
    if (this.element.paragraphStyle === TextParagraphStyle.REGULAR){ return true }
    if (this.element.paragraphStyle === TextParagraphStyle.SMALL){ return true }
    return false;
  }

  isLink(){
    return this.element.paragraphStyle === TextParagraphStyle.LINK;
  }

  isListText(){
    if (this.element.paragraphStyle === TextParagraphStyle.BULLET){ return true }
    if (this.element.paragraphStyle === TextParagraphStyle.NUMBERED){ return true }
    return false;
  }

  isAdvancedInlineText(){
    if (this.element.paragraphStyle === TextParagraphStyle.ADVANCED_INLINE){ return true }
    return false;
  }

  isAnnotation() {
    return this.element.paragraphStyle === TextParagraphStyle.ANNOTATION;
  }

  getFontFamily() {
    if (!this.whitelabel.getSiteFlag('IS_EQAO')){
      return this.element.font;
    }
    return 'inherit';
  }

  getFontSizeLink(element) {
    if (element.elementType==ElementType.BOOKMARK_LINK && element.fontSize) {
      return `${element.fontSize}em`;
    }
    return '';
  }

  getRotation() {
    if (this.element.rotation) return "rotate("+this.element.rotation+"deg)";
    return '';
  }

  getFontSize(){
    if (this.element.fontSize){
      return `${this.element.fontSize}em`;
    }
    return 'inherit';
  }

  getLineHeight() {
    if (this.element.lineHeight){
      return `${this.element.lineHeight}em`;
    }
    return '1.3em';
  }

  renderParaNum(index:number, paragraph:IContentElementTextParagraph){
    if (paragraph.numberingOverride){
      return paragraph.numberingOverride;
    }
    let start = this.element.paragraphNumberingStart || 1;
    return (+start) + index;
  }

  renderParaNumPadding(){
    return (1-(this.element.paragraphNumberingScale || 1)) / 4;
  }

  getTextStyle() {
    const style:any = {}
    style["font-family"]=this.getFontFamily();
    style["text-align"]=this.element.alignment;
    style["font-size"]=this.getFontSize();
    style["transform"]=this.getRotation();
    style["color"]= this.element.colour;
    //if (!this.isAdvancedInlineText()){
    style["line-height"]= this.getLineHeight()
    if (this.element.isNoInvertOnHiContrast && this.text2Speech.isHiContrast) {
      style["filter"]="invert(1)";
    }
    //}
    // style["user-select"]='none';
    return style;
  }

  getChildStyle() {
    const style: any = {}
    if (this.getTextStyle()["line-height"]) {
      style['line-height']='inherit'
    }
    return style;
  }

  minWidth = 10;
  getWidth() {
    if(this.isParagraphs()){
      return this.element.paragraphWidth
    }
    if (this.element.advancedInlineWidth && this.element.advancedInlineWidth >= this.minWidth) {
      return this.element.advancedInlineWidth;
    }
    return 'initial';
  }

  parseTextFormat(text:string) {
    if (!text) {
      text = ''
    }
    let regEx = /{{([0-9]+)\.(.+)}}/
    let match = text.match(regEx);
    if (match) {
      const id = match[1];
      const field = match[2];
      if (id && this.questionState[id] && this.questionState[id][field]) {
        const replaceWith = this.questionState[id][field]
        const newText = text.replace(regEx, replaceWith)
        return newText;
      }
    }
    return text;
  }

  getHeadingRole() {
    if (this.isHeading() || this.isHeadingSmall()) {
      return 'heading';
    }
    return null;
  }

  getHeadingLevel() {
    if (this.isHeading()) {
      return 2;
    }
    if (this.isHeadingSmall()) {
      return 3;
    }
    return null;
  }

  isAriaHidden() {
    return this.element && this.element.isInvisible ? 'true' : null;
  }

}
